import {combineReducers} from 'redux';
import { connectRouter } from 'connected-react-router';
import countrySelector from './countrySelector';
import profile from './profile';
import globalValidations from './globalValidations';
import catalogs from './catalogs';
import login from './login';
import location from './location';
import uiReducer from './ui/uiReducer';
import utm from './utm';
import creditoRealReducer from './creditoReal/creditoRealReducer';
import turboCashReducer from './turboCash/turboCashReducer';

const rootReducer = history => combineReducers({
    login,
    countrySelector,
    profile,
    globalValidations,
    catalogs,
    location,
    router: connectRouter(history),
    utmData: utm,
    ui: uiReducer,
    creditoReal: creditoRealReducer,
    turboCash: turboCashReducer
});

export default rootReducer;